import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderTop: '1px solid gray',
    paddingTop: 30,
    paddingBottom: 10,
    marginTop: 20
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
